import React, { useEffect, useState } from 'react';
import Sidebar from '../component/layout/sidebar';
import Header from '../component/layout/header';
import Header2 from '../component/common/title';
import AddCTA from '../component/common/addcta';
// import pic25 from '../assets/pic25.png'
// import pic26 from '../assets/pic26.png'
// import pic27 from '../assets/pic27.png'
// import pic28 from '../assets/pic28.png'
import pic30 from '../assets/pic30.png'
import pic31 from '../assets/pic31.png'
import pic32 from '../assets/pic32.png'
import { supabase } from '../supabase';
import Input from '../component/common/input';
import pic34 from '../assets/pic34.png'
import pic35 from '../assets/pic35.png'
import'./sec-category.css'
import pic36 from  '../assets/pic36.png'
import pic37 from  '../assets/pic37.png'

const Ctaegory = () => {

const [Categories, setCategories] = useState([]);
const [showForm, setShowForm] = useState(false);
// const [search, setSearch] = useState('');
// const [filter, setFilter] = useState('');
// const [sort, setSort] = useState('');
const [showDeleteModal, setShowDeleteModal] = useState(false);
const [selectedDeleteId, setSelectedDeleteId] = useState(null);
const [isEditing, setIsEditing] = useState(false);
const [editingId, setEditingId] = useState(null);
const [isSidebarOpen, setIsSidebarOpen] = useState(false);
const [events, setEvents] = useState([]);

const [formData, setFormData] = useState({
  Category_name: '',
  Category_name_ar: '',
  Event_ids: [''],
  id: ''
});









useEffect(() => {
  const getAllCategories = async () => {
    const { data, error } = await supabase
      .from('Categories')
      .select(`
        *,
        Events_Categories (
          Event_id
        )
      `);

    if (error) {
      console.log("FETCH CATEGORY ERROR:", error);
      return;
    }

    setCategories(data || []);
  };

  const getAllEvents = async () => {
    const { data, error } = await supabase
      .from('Events')
      .select('id, Event_title');

    if (error) {
      console.log("FETCH EVENTS ERROR:", error);
      return;
    }

    setEvents(data || []);
  };

  getAllCategories();
  getAllEvents();
}, []);










// const filteredBookings = Booking
//   .filter((item) => {
//     const matchesSearch =

//   (item.user_name?.toLowerCase() || '').includes(search.toLowerCase()) ||
//   (item.event_name?.toLowerCase() || '').includes(search.toLowerCase()) ||
//   (item.status?.toLowerCase() || '').includes(search.toLowerCase());
  

//     let matchesFilter = true;

//     if (filter) {
//       if (filter.startsWith('status')) {
//         matchesFilter =
//           item.status?.toLowerCase() === filter.split('-')[1];
//       }
//     }

//     return matchesSearch && matchesFilter;
//   })
//   .sort((a, b) => {
//     if (sort === 'newest') {
//       return new Date(a.booking_date) - new Date(b.booking_date);
//     }

//     if (sort === 'oldest') {
//       return new Date(b.booking_date) - new Date(a.booking_date);
//     }

//     if (sort === 'priceLow') {
//       return Number(a.total_price) - Number(b.total_price);
//     }

//     if (sort === 'priceHigh') {
//       return Number(b.total_price) - Number(a.total_price);
//     }

//     return 0;
//   });


    





const handleClose = () => {
  setShowForm(false);
  setIsEditing(false);
  setEditingId(null);
setFormData({
  Category_name: '',
  Category_name_ar: '',
  Event_ids: [''],
  id: ''
});

};

const handleEventChange = (index, value) => {
  const updatedEvents = [...formData.Event_ids];
  updatedEvents[index] = value;

  setFormData({
    ...formData,
    Event_ids: updatedEvents
  });
};

const addEventDropdown = () => {
  setFormData({
    ...formData,
    Event_ids: [...formData.Event_ids, '']
  });
};

const removeEventDropdown = (index) => {
  const updatedEvents = formData.Event_ids.filter((_, i) => i !== index);

  setFormData({
    ...formData,
    Event_ids: updatedEvents.length ? updatedEvents : ['']
  });
};









const createCategory = async () => {
  const { data, error } = await supabase
    .from('Categories')
    .insert([{
      Category_name: formData.Category_name,
      Category_name_ar: formData.Category_name_ar 
    }])
    .select();

  if (error) {
    console.log("CREATE ERROR:", error);
    return;
  }

  const newCategoryId = data[0].id;

  const validEventIds = formData.Event_ids.filter(id => id !== '');

  if (validEventIds.length > 0) {
    const links = validEventIds.map(eventId => ({
      Event_id: eventId,
      Category_id: newCategoryId
    }));

    const { error: linkError } = await supabase
      .from('Events_Categories')
      .insert(links);

    if (linkError) {
      console.log("LINK ERROR:", linkError);
      return;
    }
  }

  const { data: updatedCategories, error: fetchError } = await supabase
    .from('Categories')
    .select(`
      *,
      Events_Categories (
        Event_id
      )
    `);

  if (fetchError) {
    console.log("REFRESH ERROR:", fetchError);
    return;
  }

  setCategories(updatedCategories || []);
  handleClose();
};











const confirmDelete = async () => {
  const id = selectedDeleteId;
await supabase.from('Events_Categories').delete().eq('Category_id', id);
  await supabase.from('Categories').delete().eq('id', id);

  setCategories(prev => prev.filter(event => event.id !== id));

  setShowDeleteModal(false);
  setSelectedDeleteId(null);
};





const handleEditClick = (item) => {
  setFormData({
    Category_name: item.Category_name || '',
     Category_name_ar: item.Category_name_ar || '', 
    Event_ids: item.Events_Categories?.map(e => e.Event_id) || [''],
    id: item.id || '',
  });

  setEditingId(item.id);
  setIsEditing(true);
  setShowForm(true);
};


const updateCategory = async () => {
  const { error } = await supabase
    .from('Categories')
    .update({
      Category_name: formData.Category_name,
            Category_name_ar: formData.Category_name_ar
    })
    .eq('id', editingId);

  if (error) {
    console.log("UPDATE ERROR:", error);
    return;
  }

  await supabase
    .from('Events_Categories')
    .delete()
    .eq('Category_id', editingId);

  const validEventIds = formData.Event_ids.filter(id => id !== '');

  if (validEventIds.length > 0) {
    const links = validEventIds.map(eventId => ({
      Event_id: eventId,
      Category_id: editingId
    }));

    const { error: linkError } = await supabase
      .from('Events_Categories')
      .insert(links);

    if (linkError) {
      console.log("UPDATE LINK ERROR:", linkError);
      return;
    }
  }

  const { data: updatedCategories, error: fetchError } = await supabase
    .from('Categories')
    .select(`
      *,
      Events_Categories (
        Event_id
      )
    `);

  if (fetchError) {
    console.log("REFRESH ERROR:", fetchError);
    return;
  }

  setCategories(updatedCategories || []);
  handleClose();
};



    return ( 
 
 <section className='main-dashboard-container'>            
            <Sidebar isOpen={isSidebarOpen}  /> 
            <section className='container-right-info'>
                    <section className='header-container'>
                        <Header  onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)}  />
                    </section>

                    <section className='information-container'>
                        <article className='header-cont-event'>
                           <Header2 
                            title="Categories Management"  
                            para="Organize your events into categories"
                            />
                          <AddCTA    title='Add Category'   onClick={() => setShowForm(true)} />
                        
                        </article>



{showForm && (
  <div className="overlay-create">
    <div className="container-create">

      <div className="header-create">
            <h1 className="title-create">
            {isEditing ? 'Edit Category' : 'Add New Category'}
            </h1>

        <button
          className="close-btn-create"
          onClick={handleClose}
          type="button"
        >
          <img src={pic34} alt='close' />
        </button>
      </div>




      <form className="form-create"  onSubmit={(e) => {
                e.preventDefault();
            isEditing ? updateCategory() : createCategory();
            }}>

                                <fieldset className="field-group-create">
                                    <Input
                                        title='Category Name'
                                        placeholder='Enter category name'
                                        type="text"
                                      value={formData.Category_name}
                                      onChange={(e) =>
                                        setFormData({ ...formData, Category_name: e.target.value })
                                      }
                                    />
                                </fieldset>

                              <fieldset className="field-group-create">
                                <Input
                                  title='Category Name (Arabic)'
                                  placeholder='Enter category name in Arabic'
                                  type="text"
                                  value={formData.Category_name_ar}
                                  onChange={(e) =>
                                    setFormData({ ...formData, Category_name_ar: e.target.value })
                                  }
                                />
                              </fieldset>

                              <fieldset className="field-group-create">
                                <fieldset className="fieldset">
                                  <label className='title-input'>Events</label>

                                  {formData.Event_ids.map((eventId, index) => (
                                    <div key={index} style={{ marginBottom: '12px' }}>
                                      <select
                                        className="input-search2 select-style2"
                                        value={eventId}
                                        onChange={(e) => handleEventChange(index, e.target.value)}
                                      >
                                        <option value="">Select Event</option>
                                        {events.map((event) => (
                                          <option key={event.id} value={event.id}>
                                            {event.Event_title}
                                          </option>
                                        ))}
                                      </select>

                                      {formData.Event_ids.length > 1 && (
                                       <button
                                        type="button"
                                        className="remove-event-btnnn"
                                        onClick={() => removeEventDropdown(index)}
                                      >
                                        Remove
                                      </button>
                                      )}
                                    </div>
                                  ))}
                                </fieldset>
                              </fieldset>

                                    <button
                                      type="button"
                                      className='addnew-inputt'
                                      onClick={addEventDropdown}
                                    >
                                      <h2 className='title-add-category-form'>Add new event</h2>
                                      <img src={pic37} alt='' />
                                    </button>
                               
                                <nav className='container-ctas-craete'>
                                                 <button   type="button" className="cta-cancel-create" onClick={handleClose}>
                                                        <h2 className="cta-cancel-text-create">
                                                                                            Cancel
                                                        </h2>
                                                  </button>
                                                    
                                                  <button type="submit" className='cta-create'>
                                                        <h2 className='cta-create-text'>
                                                                 {isEditing ? 'Edit category' : 'Add category'}
                                                          </h2>
                                                   </button>
                                 </nav>
                                

      </form>
    </div>
  </div>
)}






{showDeleteModal && (
  <section className="delete-modal-overlay">
    <article className="delete-modal" role="dialog" aria-modal="true">
      
      <header className="delete-modal-header">
        <div className="delete-icon-wrapper">
          <img src={pic35} alt='icon'></img>
        </div>

        <div className="delete-text-container">
          <h2 className="delete-title">Delete Category</h2>
          <p className="delete-description">
            Are you sure you want to delete this category? This action cannot be undone.
          </p>
        </div>
      </header>

      <nav className="delete-modal-actions">
        <button
          className="delete-btn-cancel"
          onClick={() => {
            setShowDeleteModal(false);
            setSelectedDeleteId(null);
          }}
        >
          Cancel
        </button>

        <button
          className="delete-btn-confirm"
          onClick={confirmDelete}
        >
          Delete
        </button>
      </nav>

    </article>
  </section>
)}






                        <section className='container-table-category'>
                            
 {Categories.map((item) => { return <article className='card-category' key={item.id}>
                                                    <nav className='cta-table'>
                                                            <button className='cta2-table'>
                                                                <img src={pic30} alt='hide'></img>
                                                            </button>
                                                            <button
                                                            className='cta2-table'
                                                            onClick={() => handleEditClick(item)}
                                                            >
                                                            <img src={pic31} alt='edit' />
                                                            </button>
                                                            <button
                                                            className='cta2-table'
                                                            onClick={() => {
                                                                setSelectedDeleteId(item.id);
                                                                setShowDeleteModal(true);
                                                            }}
                                                            >
                                                            <img src={pic32} alt='delete' />
                                                            </button>
                                                            
                                                    </nav>

                                                    <article className='box1-caregory'>

                                                            <h2 className='header-categoryy'>{item.Category_name}</h2>
                                                            <h3 className='id-category'>{item.id}</h3>

                                                    </article>

                                                    <article className='box1-caregory'>
                                                            <h2 className='header-categoryy-ar'>{item.Category_name_ar}</h2>
                                                    </article>

                                                    <article className='events-numb-category-cont'>
                                                            {item.Events_Categories?.length || 0}  events
                                                            <img src={pic36} alt='pic'></img>
                                                    </article>










                                    </article>
                                     })}

                        </section>







                    </section>

            </section>
        </section>

     );
}
 
export default Ctaegory;